{
  "actions": "Handlinger",
  "hideButtonLabel": "Vis mindre",
  "noTags": "Ingen",
  "showAllButtonLabel": "Vis alle ({tagCount, number})"
}
